import React, { ReactNode, useEffect, useRef } from 'react'

// Utils
import classnames from 'classnames'

// Dependencies
import ProductDetailsIcon from '../productDetailsIcon'
import Image from '@src/quince-site-common/src/domains/Image'

import { isEmpty } from '@src/utils/functions/utils'
// Styles
import styles from './productDetails.module.scss'
import removeTargetAttributeForHashAnchorTags from '@src/quince-site-common/src/utils/removeTargetAttributeForHashAnchorTags'

export interface ProductDetailsProps {
  textContent: ReactNode
  icons: {
    displayTitle: string
    image?: Image
  }[]
  className?: string
  shadowClassName?: string
}

const ProductDetails = ({ textContent, icons, className, shadowClassName }: ProductDetailsProps) => {
  const classes = classnames(className, styles.productDetails)
  const productDetailsDivWrapper = useRef<HTMLDivElement>(null)
  useEffect(() => {
    removeTargetAttributeForHashAnchorTags(productDetailsDivWrapper.current)
  }, [])

  return (
    <div className={classes} ref={productDetailsDivWrapper}>
      <div className={styles.productDetails__textContent}>{textContent}</div>
      {!isEmpty(icons) && (
        <div className={styles.productDetails__iconsContainer}>
          {icons.map(icon => (
            <ProductDetailsIcon key={icon.displayTitle} displayTitle={icon.displayTitle} image={icon.image} />
          ))}
        </div>
      )}
      <div className={shadowClassName}></div>
    </div>
  )
}

export default ProductDetails
